import { isEmpty, setProperty } from "../../util/util";
import { MODULE_PREFIX, SLOT_PREFIX } from "../Constants";

const InitialState = {
	inventoryData: {},
	replenishPlanData: [],
	replenishPlan: [],
	replenishmentData: {},
};

export function deepCopy(obj) {
	return JSON.parse(JSON.stringify(obj));
}

export const operations = (state = InitialState, action) => {
	switch (action.type) {
		case "GET_INVENTORY_DATA":
			return {
				...state,
				inventoryData: action.data,
			};

		case "ADD_DISH_TO_REPLENISH":
			return {
				...state,
				replenishPlanData: [...state.replenishPlanData, action.data],
			};

		case "REMOVE_DISH_TO_REPLENISH":
			return {
				...state,
				replenishPlanData: state.replenishPlanData.filter(
					(dish) => dish._id !== action.data
				),
			};

		case "UPDATE_DISH_TO_REPLENISH":
			const { index, column, value } = action.data;
			let newData = state.replenishData;
			let dish = newData[index];
			dish[column] = value;
			newData[index] = dish;
			return {
				...state,
				replenishPlanData: [...newData],
			};

		case "SET_REPLENISH_PLAN":
			return {
				...state,
				replenishPlan: action.data,
			};

		case "ADD_TO_REPLENISH_DATA":
			const { moduleId, slotId, ...payload } = action.data;
			let updatedReplenishmentPayload = deepCopy(state.replenishmentData);
			setProperty(updatedReplenishmentPayload, payload, `${moduleId}.${slotId}`);
			return {
				...state,
				replenishmentData: updatedReplenishmentPayload,
			};

		case "UPDATE_REPLENISH_DATA":
			const { moduleToUpdate, slotToUpdate, ...updatedPayload } = action.data;
			const { moduleId:newModuleId , slotId:newSlotId, ...updatedData } = updatedPayload;
			let newPayload = deepCopy(state.replenishmentData);
			if(newModuleId !== moduleToUpdate || newSlotId !== slotToUpdate) {
				let payload = { ...newPayload[moduleToUpdate][slotToUpdate], ...updatedData };
				setProperty(newPayload, payload, `${newModuleId}.${newSlotId}`);
				delete newPayload[moduleToUpdate][slotToUpdate];
			} else {
				newPayload[moduleToUpdate][slotToUpdate] = { ...newPayload[moduleToUpdate][slotToUpdate], ...updatedData }
			}

			return {
				...state,
				replenishmentData:newPayload
			}
			
		case "REMOVE_FROM_REPLENISH_DATA": 
			const { moduleId:moduleToRemoveFrom, slotId:slotToRemove } = action.data;
			let newReplenishmentPayload = deepCopy(state.replenishmentData);

			if(slotToRemove) {
				delete newReplenishmentPayload[moduleToRemoveFrom][slotToRemove];
				//Remove the module if its empty
				if(isEmpty(newReplenishmentPayload[moduleToRemoveFrom])) {
					delete newReplenishmentPayload[moduleToRemoveFrom];
				}
			} else {
				delete newReplenishmentPayload[moduleToRemoveFrom];
			} 

			return {
				...state,
				replenishmentData: newReplenishmentPayload,
			};

		case "CLEAR_REPLENISHMENT_DATA": 
			return {
				...state,
				replenishmentData: {}
			}

		case "CLEAR_DATA":
			return InitialState;

		default:
			return {
				...state,
			};
	}
};

export default operations;
